import React, { useContext } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

import axios from 'axios';

import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';

import { NCRContext } from 'views';
import { useFormContext } from 'react-hook-form';

const SubmitButton = ({
  request,
  name,
  validate,
  variant,
  toast,
  handleModal,
}) => {
  const { state, setState, setLoading, setToasts } = useContext(NCRContext);
  const { handleSubmit } = useFormContext();

  const history = useHistory();
  const location = useLocation();

  var isDisabled = !state.ncr.original_so_number || !state.ncr.subsidiary;

  if (
    location.pathname === '/create_return' ||
    location.pathname.includes('/return')
  ) {
    isDisabled = !state.ncr.original_customer_number || !state.ncr.subsidiary;
  }

  const callback = (rejection) => {
    // setLoading(true);
    const { data: ncr, ...req } = request;
    const formData = new FormData();
    formData.append('payload', JSON.stringify(ncr));
    if (rejection) {
      formData.append('rejection', rejection);
    }
    if (state.uploads.length > 0) {
      Object.values(state.uploads).forEach((file) => {
        formData.append('attachments', file);
      });
    }
    axios({ ...req, data: formData })
      .then(({ data: ncr }) => {
        // setState((prev) => ({ ...prev, ncr: { ...ncr } }));
        // setToasts((prev) => [...prev, toast]);
        if (
          location.pathname.includes('/return') ||
          location.pathname === '/create_return'
        ) {
          // history.replace(`/return/${ncr.id}`);
          // history.push(`/redirect/return/${ncr.id}`);
          window.location.href = `/return/${ncr.id}`;
        } else {
          // history.replace(`/ncr/${ncr.id}`);
          // history.push(`/redirect/ncr/${ncr.id}`);
          window.location.href = `/ncr/${ncr.id}`;
        }
      })
      .catch((err) => handleConflict(err));
    // .finally(() => setLoading(false));
  };

  const handleConflict = (err) => {
    if (err.response.status === 409) {
      setToasts((prev) => [
        ...prev,
        {
          message:
            'This NCR has been updated by another user.\nPlease refresh the page and input your changes again.',
          color: 'LightPink',
        },
      ]);
    } else {
      console.error(err);
    }
  };

  const onClick = () => {
    const cb = () => (handleModal ? handleModal(callback) : callback());
    const fn = () => (validate ? handleSubmit(cb)() : cb());
    fn();
  };

  return (
    <>
      <Col md className={'mb-2 text-center'}>
        <Button
          onClick={onClick}
          disabled={isDisabled}
          size="lg"
          variant={variant || 'warning'}
          style={{
            width: '100%',
            maxWidth: '200px',
          }}
        >
          {name}
        </Button>
      </Col>
    </>
  );
};

export { SubmitButton };
